import { render, staticRenderFns } from "./Galeria.vue?vue&type=template&id=420ff671"
import script from "./Galeria.vue?vue&type=script&lang=js"
export * from "./Galeria.vue?vue&type=script&lang=js"
import style0 from "./Galeria.vue?vue&type=style&index=0&id=420ff671&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports